(() => {
  const GATE_SELECTOR = '[data-stamp-upload][data-required="true"]';
  const CHECKOUT_SELECTOR = '.m-product-dynamic-checkout';
  const UPLOAD_ID_SELECTOR = '[data-upload-id-property]';
  const UPLOAD_INPUT_SELECTOR = '[data-upload-input]';
  const UPLOAD_TRIGGER_SELECTOR = '[data-upload-trigger]';
  const UPLOAD_PREVIEW_SELECTOR = '[data-upload-preview] img';
  const MESSAGE_CLASS = 'printmivo-upload-gate__message';
  const MESSAGE_TEXT = 'Upload your logo to buy now.';

  class UploadGate {
    constructor(uploader) {
      this.uploader = uploader;
      this.scope = uploader.closest('.m-product-info--wrapper') || uploader.parentElement;
      if (!this.scope) return;

      this.onUploadActivity = this.sync.bind(this);
      this.onBlockedClick = this.blockCheckout.bind(this);
      this.observer = new MutationObserver(this.onUploadActivity);
      this.observer.observe(this.scope, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['data-upload-state', 'disabled', 'value']
      });
      this.uploader.addEventListener('change', this.onUploadActivity);
      this.uploader.addEventListener('input', this.onUploadActivity);
      this.scope.addEventListener('click', this.onBlockedClick, true);
      this.sync();
    }

    get uploadIdInput() {
      return this.uploader.querySelector(UPLOAD_ID_SELECTOR);
    }

    get checkout() {
      return this.scope.querySelector(CHECKOUT_SELECTOR);
    }

    get isUploaded() {
      const uploadIdInput = this.uploadIdInput;
      const uploadInput = this.uploader.querySelector(UPLOAD_INPUT_SELECTOR);
      const uploadTrigger = this.uploader.querySelector(UPLOAD_TRIGGER_SELECTOR);
      const uploadIdReady = Boolean(
        uploadIdInput && !uploadIdInput.disabled && String(uploadIdInput.value || '').trim()
      );
      const selectionReady = Boolean(
        uploadTrigger?.dataset.uploadState === 'uploaded' &&
        this.uploader.querySelector(UPLOAD_PREVIEW_SELECTOR) &&
        (uploadInput?.files?.length || String(uploadInput?.value || '').trim())
      );

      return uploadIdReady || selectionReady;
    }

    get message() {
      return this.scope.querySelector(`.${MESSAGE_CLASS}`);
    }

    ensureMessage(checkout) {
      let message = this.message;
      if (!message) {
        message = document.createElement('p');
        message.className = MESSAGE_CLASS;
        message.id = `PrintmivoUploadGate-${this.uploader.id || Math.random().toString(36).slice(2)}`;
        message.hidden = true;
        message.setAttribute('role', 'alert');
        message.textContent = MESSAGE_TEXT;
        checkout.insertAdjacentElement('afterend', message);
      }
      return message;
    }

    sync() {
      const checkout = this.checkout;
      if (!checkout) return;

      const uploaded = this.isUploaded;
      checkout.dataset.printmivoUploadLocked = String(!uploaded);
      checkout.removeAttribute('aria-disabled');

      const message = this.ensureMessage(checkout);
      if (uploaded) message.hidden = true;

      checkout.querySelectorAll('button').forEach((button) => {
        button.removeAttribute('aria-describedby');
      });
    }

    blockCheckout(event) {
      if (this.isUploaded) return;
      const checkout = event.target.closest?.(CHECKOUT_SELECTOR);
      if (!checkout || !this.scope.contains(checkout)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const message = this.ensureMessage(checkout);
      message.hidden = false;
      checkout.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-describedby', message.id);
      });
    }
  }

  const initUploadGates = (root = document) => {
    root.querySelectorAll(GATE_SELECTOR).forEach((uploader) => {
      if (uploader.dataset.printmivoGateReady === 'true') return;
      uploader.dataset.printmivoGateReady = 'true';
      new UploadGate(uploader);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUploadGates(), { once: true });
  } else {
    initUploadGates();
  }

  new MutationObserver(() => initUploadGates()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
